import { api } from '../../core/network/api';

/** One clan on the public roll. */
export interface ClanRow {
  id: string;
  name: string;
  tag: string;
  /** Index into the fixed banner rack (banner-0..banner-9.webp). */
  banner: number;
  members: number;
  points: number;
  isMine: boolean;
  /** The caller has a plea pending with this clan. */
  requested: boolean;
}

/** One plea knocking at the hall — the leader sees these on `mine`. */
export interface ClanPleaRow {
  id: string;
  userId: string;
  username: string | null;
  createdAt: string;
}

/** A member of MY clan, strongest first. */
export interface ClanMemberRow {
  userId: string;
  username: string | null;
  points: number;
  isLeader: boolean;
  joinedAt: string;
}

/** My clan in full — null when unsworn. */
export interface MyClan {
  id: string;
  name: string;
  tag: string;
  /** Index into the fixed banner rack (banner-0..banner-9.webp). */
  banner: number;
  leaderId: string;
  isLeader: boolean;
  points: number;
  members: ClanMemberRow[];
  maxMembers: number;
  foundCost: number;
  /** Pending pleas — populated for the leader, empty for everyone else. */
  requests: ClanPleaRow[];
}

export const fetchClans = () => api.get<{ clans: ClanRow[]; inClan: boolean }>('/clans');
export const fetchMyClan = () => api.get<{ clan: MyClan | null }>('/clans/mine');
export const createClan = (name: string, tag: string, banner = 0) =>
  api.post<{ clan: MyClan }>('/clans', { name, tag, banner });
/** Joining is a plea now — these return the refreshed roll, not a membership. */
export const requestJoin = (id: string) =>
  api.post<{ clans: ClanRow[]; inClan: boolean }>(`/clans/${id}/join`, {});
export const cancelJoinRequest = (id: string) =>
  api.del<{ clans: ClanRow[]; inClan: boolean }>(`/clans/${id}/join`);
/** Leader only — both return the refreshed hall. */
export const acceptPlea = (requestId: string) =>
  api.post<{ clan: MyClan }>(`/clans/requests/${requestId}/accept`, {});
export const declinePlea = (requestId: string) =>
  api.post<{ clan: MyClan }>(`/clans/requests/${requestId}/decline`, {});
export const leaveClan = () => api.post<{ left: true }>('/clans/leave', {});
export const kickMember = (userId: string) => api.post<{ clan: MyClan }>('/clans/kick', { userId });
